import { ThemeOptions } from "@mui/material";
import { deepmerge } from '@mui/utils';

//cfe8e0 
//ffc683

const commonTheme: ThemeOptions = {
  shape: {
    borderRadius: 10
  },
  typography: {
    allVariants: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"'].join(','),
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
                @font-face {
                  font-family: 'Inter';
                }
              `,
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingTop: '10px',
          paddingBottom: '10px',
        }
      },
    }
  }
}

const lightTheme: ThemeOptions = {
  typography: {
    allVariants: {
      color: '#606060'
    }
  },
  palette: {
    primary: {
      main: '#363636',
    },
    secondary: {
      main: '#848484'
    },
    info: {
      main: '#f4f4f4',
      light: '#e1c5e6',
      dark: '#5d809b'
    },
    success: {
      main: '#008457',
      light: '#008457',
      dark: '#ffffff'
    },
    text: {
      primary: '#363636',
      secondary: '#848484'
    },
    background: {
      default: '#f4f4f4', //'#ffffff',
      paper: '#ffffff'
    },
    action: {
      //active: '#f4f4f4',
      selected: '#cfe8e0',
      hover: '#bcbcbc', // '#ededed',
      disabled: '#848484',
      //disabledBackground: string;
      focus: '#ededed'
      //focus: '#606060'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root:
          ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'secondary' && {
              backgroundColor: '#ffffff',
              "&:hover": {
                backgroundColor: '#b5b5b5'
              }
            },
              ownerState.color === 'primary' && {
                color: '#ffffff',
                backgroundColor: '#008457',
                "&:hover": {
                  backgroundColor: '#00AE73'
                }
              })
          })
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root:
          ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'secondary' && {
              backgroundColor: '#ffffff',
              "&:hover": {
                backgroundColor: '#b5b5b5'
              }
            },
              ownerState.color === 'primary' && {
                color: '#ffffff',
                backgroundColor: '#008457',
                "&:hover": {
                  backgroundColor: '#00AE73'
                }
              })
          })
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#848484',
          '&.Mui-checked': {
            color: '#848484'
          },
        },
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          backgroundColor: '#e0e0e0',
          "&:hover": {
            backgroundColor: '#b5b5b5'
          }
        }
      }
    }
  }
}

const darkTheme: ThemeOptions = {
  typography: {
    allVariants: {
      color: '#ffffff'
    },
  },
  palette: {
    primary: {
      main: '#ffffff', // 363636
    },
    secondary: {
      main: '#b7b7b7' // 848484 => 515151
    },
    info: {
      main: '#282828', // f4f4f4
      light: '#eeb9dc', //'#e1c5e6',
      dark: '#5d809b'
    },
    success: {
      main: '#008457',
      light: '#ffffff',
      dark: '#ffffff'
    },
    text: {
      primary: '#ffffff',  // 363636
      secondary: '#b7b7b7'  // 848484
    },
    background: {
      default: '#282828',   //202020 // ffffff
      paper: '#202020'    //ffffff => 181818
    },
    action: {
      active: '#f4f4f4',    //f4f4f4
      selected: '#2b5a4b',    // cfe8e0
      hover: '#545454',       //ededed
      disabled: '#b7b7b7',
      //disabled: string;
      //disabledBackground: string;
      focus: '#202020'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root:
          ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'secondary' && {
              backgroundColor: '#202020',
              "&:hover": {
                backgroundColor: '#4f4f4f'
              }
            },
              ownerState.color === 'primary' && {
                color: '#ffffff',
                backgroundColor: '#008457',
                "&:hover": {
                  backgroundColor: '004830'
                }
              })
          })
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root:
          ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'secondary' && {
              backgroundColor: '#202020',
              "&:hover": {
                backgroundColor: '#4f4f4f'
              }
            },
              ownerState.color === 'primary' && {
                color: '#ffffff',
                backgroundColor: '#008457',
                "&:hover": {
                  backgroundColor: '004830'
                }
              })
          })
      }
    },
    //MuiFormLabel:
    MuiInputLabel:{
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#5b5b5b'
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#5b5b5b' //'#282828'
            },
            '&.Mui-disabled': {
              color: 'red'
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&.Mui-disabled': {
            '-webkit-text-fill-color': '#5b5b5b',
          }
        },
        notchedOutline: 
        {
          borderColor: '#5b5b5b', //'#282828'
         
        },
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'red' //'#282828'
            },
          '&.Mui-disabled': {
              color: 'green !important'
            }
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#515151',
          '&.Mui-checked': {
            color: '#515151'
          },
        },
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: '#202020'
        }
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          backgroundColor: '#8c8989', // '#e0e0e0',8c8989
          "&:hover": {
            backgroundColor: '#4f4f4f' // b5b5b5  4f4f4f
          }
        }
      }
    }
  }
}

export const getDesignTokens = (darkModeEnabled: boolean): ThemeOptions =>
  deepmerge(darkModeEnabled ? darkTheme : lightTheme, commonTheme)